import {ApiClient} from './api-client';

export class RequestService extends ApiClient {
  public async updateRequestDrug(
    id: number,
    data: {
      amount_due?: string;
      quantity?: number;
      total_amount?: number;
      cash_price?: number;
    }
  ) {
    return this.patch(`/requests/drug/${id}/`, data);
  }
}
